var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import WidgetDisplay from "../widgets/widgetDisplay";
import { Slot, SlotDirection } from "@/utils/types/layout";
import { useLayout, usePopup } from "@/hooks/layout";
import { useLogger } from "@/utils/loggerService";
import { updateWidget } from "@/store/layoutSlice";
import widgetsDictionary from "../widgets/widgetsDictionary";
import { smallSlot } from "../forms/components/utils";
import { useAppDispatch, useAppSelector } from "@/hooks/store";
import { IconButton } from "@mui/joy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
var WidgetGrid = function (_a) {
    var _b;
    var filteredWidgets = _a.filteredWidgets, isEditingLayout = _a.isEditingLayout, _c = _a.direction, direction = _c === void 0 ? SlotDirection.HORIZONTAL : _c, isSmallSlot = _a.isSmallSlot;
    var spanTotal = 0;
    var showPopup = usePopup().showPopup;
    var logger = useLogger().logger;
    var dispatch = useAppDispatch();
    var removeWidget = useLayout().removeWidget;
    var hasDefault = useAppSelector(function (state) { return state.theme; }).hasDefault;
    var gridClass = direction === SlotDirection.HORIZONTAL
        ? "grid grid-cols-4  auto-rows-fr w-full h-full justify-center "
        : "grid grid-rows-4 auto-cols-fr w-full h-full justify-center ";
    // Map span to Tailwind class
    var spanClassMap = (_b = {},
        _b[SlotDirection.HORIZONTAL] = {
            1: "col-span-1",
            2: "col-span-2",
            3: "col-span-3",
            4: "col-span-4",
        },
        _b[SlotDirection.VERTICAL] = {
            1: "row-span-1",
            2: "row-span-2",
            3: "row-span-3",
            4: "row-span-4",
        },
        _b);
    return (_jsxs("div", __assign({ className: " ".concat(gridClass, " ").concat(isSmallSlot ? "  gap-2 min-w-[220px] " : "p-5 gap-5 ", " ").concat(!isEditingLayout && isSmallSlot && "py-1", " ") }, { children: [filteredWidgets.map(function (widget) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var span = (_b = (_a = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 1;
                spanTotal += span;
                var spanClass = (_c = spanClassMap[direction][span]) !== null && _c !== void 0 ? _c : spanClassMap[direction][1];
                var handleWidgetClick = function (widget) { return __awaiter(void 0, void 0, void 0, function () {
                    var updatedWidget;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!isEditingLayout || widget.slot === Slot.MAIN)
                                    return [2 /*return*/];
                                return [4 /*yield*/, showPopup({
                                        type: "widget/editor",
                                        payload: { widget: widget, allWidgets: filteredWidgets },
                                    })];
                            case 1:
                                updatedWidget = (_a.sent()).reason;
                                if (updatedWidget === null || updatedWidget === void 0 ? void 0 : updatedWidget.type) {
                                    logger.debug("[UPDATE_WIDGET_SETTINGS] Updated:", updatedWidget);
                                    dispatch(updateWidget({
                                        id: updatedWidget.id,
                                        type: updatedWidget.type,
                                        slot: updatedWidget.slot,
                                        widget: updatedWidget,
                                    }));
                                }
                                else {
                                    logger.debug("[UPDATE_WIDGET_SETTINGS] Update cancelled");
                                }
                                return [2 /*return*/];
                        }
                    });
                }); };
                return (_jsx("div", __assign({ className: "".concat(spanClass, " flex flex-col") }, { children: _jsxs("div", __assign({ onClick: function () { return handleWidgetClick(widget); }, className: "  items-center  ".concat(isSmallSlot && "flex justify-center", "   rounded-[var(--border-widget)]  mt-[var(--margin-mt-widget)] mr-[var(--margin-mr-widget)] mb-[var(--margin-mb-widget)] ml-[var(--margin-ml-widget)]\n                 ").concat(!isSmallSlot &&
                            isEditingLayout &&
                            " hover:bg-[var(--colors-widget-hover)] ", "\n                ").concat(isEditingLayout &&
                            widget.slot !== Slot.MAIN &&
                            "cursor-pointer rounded-[17px] transform transition-transform duration-100 hover:scale-[1.01] !ml-0 !mr-0 border border-gray-400 ", "\n\n              ").concat(((_d = widgetsDictionary.get(widget === null || widget === void 0 ? void 0 : widget.type)) === null || _d === void 0 ? void 0 : _d.selectable) !== false &&
                            hasDefault &&
                            (((_e = widget.payload) === null || _e === void 0 ? void 0 : _e.relationship) === true ||
                                ((_f = widget.payload) === null || _f === void 0 ? void 0 : _f.relationship) === undefined) &&
                            "bg-[var(--colors-widget)]", "\n\n               ").concat(isEditingLayout &&
                            widget.slot !== Slot.MAIN &&
                            ((_g = widgetsDictionary.get(widget === null || widget === void 0 ? void 0 : widget.type)) === null || _g === void 0 ? void 0 : _g.selectable) !== false &&
                            hasDefault &&
                            "cursor-pointer rounded-[17px] bg-[var(--colors-widget)] transform transition-transform duration-100 hover:scale-[1.01] !ml-0 !mr-0 border border-gray-400 ", "\n\n\n              !h-full ").concat(!isEditingLayout
                            ? direction === SlotDirection.HORIZONTAL
                                ? "!w-full h-full overflow-x-hidden hover:overflow-x-auto"
                                : "!w-full  !h-full overflow-y-hidden hover:overflow-y-auto"
                            : "!w-full  flex-1 ", "\n\n              ") }, { children: [isEditingLayout &&
                                (widget === null || widget === void 0 ? void 0 : widget.slot) &&
                                !smallSlot.includes(widget.slot) &&
                                widget.slot !== Slot.MAIN && (_jsx("div", __assign({ className: "absolute inset-0 flex items-center justify-center pointer-events-none" }, { children: (_h = widgetsDictionary === null || widgetsDictionary === void 0 ? void 0 : widgetsDictionary.get(widget === null || widget === void 0 ? void 0 : widget.type)) === null || _h === void 0 ? void 0 : _h.name }))), isEditingLayout && widget.slot !== Slot.MAIN && (_jsx(_Fragment, { children: _jsx(IconButton, __assign({ onClick: function (e) {
                                        e.stopPropagation();
                                        removeWidget(widget);
                                    }, sx: function () {
                                        var isSmall = (widget === null || widget === void 0 ? void 0 : widget.slot) && smallSlot.includes(widget.slot);
                                        var size = isSmall ? 15 : 24;
                                        var top = -5;
                                        var fontSize = isSmall ? "12px" : "14px";
                                        return {
                                            position: "absolute",
                                            top: top,
                                            zIndex: 1,
                                            right: 0,
                                            width: size,
                                            height: size,
                                            minWidth: size,
                                            minHeight: size,
                                            borderRadius: "50%",
                                            backgroundColor: "var(--colors-danger-outlinedColor)",
                                            color: "white",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: 0,
                                            fontSize: fontSize,
                                            "&:hover": {
                                                backgroundColor: "var(--colors-danger-solidHoverBg)",
                                                color: "white",
                                            },
                                        };
                                    } }, { children: _jsx(FontAwesomeIcon, { icon: faClose }) })) })), _jsx(WidgetDisplay, { widget: widget }, widget.id)] })) }), "".concat(widget.id)));
            }), isEditingLayout &&
                Array.from({ length: 4 - spanTotal }).map(function (_, i) { return (_jsx("div", { className: "".concat(direction === SlotDirection.HORIZONTAL
                        ? "col-span-1 "
                        : "row-span-1 ", " flex w-full h-full flex-row rounded-[17px] border-2 border-dashed border-gray-400 bg-gray-300 opacity-30  ") }, "placeholder-".concat(i))); })] })));
};
export default WidgetGrid;
